import React from 'react'

const DividerIcon = () => {
  return (
    <svg
      width="1"
      height="31"
      viewBox="0 0 1 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="0.15" x2="0.15" y2="31" stroke="#999FAC" strokeWidth="0.3" />
    </svg>
  )
}

export default DividerIcon
